import { Button } from "flowbite-react";
import { FiChevronLeft } from "react-icons/fi";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const ButtonBack = (props) =>   {
    const tmpProps = {
        ...props,
        theme: tenkenTheme.button,
        color: "gray",
        className: `rounded-[6px] lg:min-w-[280px] min-w-[240px] lg:h-10 h-[38px] ${props.className}`,
    };

    return (
        <Button {...tmpProps}>
          <FiChevronLeft className="lg:h-5 lg:w-5 h-[18px] w-[18px] mr-[4px]" />
          戻る
        </Button>
      );
};

export default ButtonBack;